import { UserAction } from "@brookbush/types";

import { motion } from "framer-motion";
import { Info } from "lucide-react";
import { memo } from "react";

import { useUserAction } from "~/hooks";
import { buttonVariants } from "~/lib/animations.lib";

const CourseInfoButton = () => {
	const { setUserAction } = useUserAction();
	return (
		<motion.button
			id="course-info-btn"
			onClick={() => setUserAction(UserAction.COURSE_DETAILS)}
			whileTap={buttonVariants.loading}
			className="flex h-min max-w-max shrink-0 items-center justify-center gap-1.5 phablet:gap-1.5 rounded-full bg-slate-100 phablet:px-3 px-4 phablet:py-1.5 py-2 font-medium text-base text-black hover:bg-slate-200 dark:bg-slate-700 dark:text-slate-50 dark:hover:bg-slate-600"
		>
			<Info className="h-5 w-5 shrink-0" />

			<span className="phablet:block hidden">Details</span>
		</motion.button>
	);
};

export default memo(CourseInfoButton);
